<template>
    <article id="homePage" class="home-page page">
        <Hero />    
        <div class="container-xl">            
            <FeaturedProduct />
        </div>  
        <FeaturedB2BBlock v-if="currentLang=='en' || currentLang=='ru'"/>
       <FeaturedRecipes v-if="currentLang=='hu'" />
       <FeaturedNews v-if="currentLang=='hu'"/>
    </article>
</template>

<script>
import Hero from '@/components/pagesComponents/homePageComponents/Hero.vue'
import FeaturedProduct from '@/components/pagesComponents/products/FeaturedProduct.vue'
import FeaturedRecipes from "@/components/pagesComponents/recipes/FeaturedRecipes.vue"
import FeaturedNews from "@/components/pagesComponents/news/FeaturedNews.vue"
import FeaturedB2BBlock from "@/components/pagesComponents/homePageComponents/FeaturedB2BBlock.vue"

import '@/css/homepage.css'

export default {  
    components:{
        Hero,
        FeaturedProduct,
        FeaturedRecipes,
        FeaturedNews,
        FeaturedB2BBlock
    },
    computed:{
        currentLang(){
            let lang = this.$store.getters.getSelectedLang.name

            if (lang == null) {
                return 'hu'
            } else {
                return this.$store.getters.getSelectedLang.name.toLowerCase()
            }
            
        }
    },
    mounted(){
        this.setMetaTags({
            title: 'Univer', 
            desc: this.lang('meta_description_homepage'), 
            keywords:this.lang('meta_keywords_homepage'), 
            ogType: 'website', 
            ogTitle: 'Univer',                         
            ogImage: null, 
            ogImageWidth: null, 
            ogImageHeight: null, 
            ogDesc:this.lang('meta_description_homepage')
        })
    }    
}
</script>